import ChevronButton from "./buttons/chevron-button"

const Pagination = ({ currentPage, totalPages, onChange, activeStyle = "bg-[#086375]" }) => {
  const blockSize = 5

  const currentBlock = Math.floor((currentPage - 1) / blockSize)
  const start = currentBlock * blockSize + 1
  const end = Math.min(start + blockSize - 1, totalPages)
  const pages = Array.from({ length: end - start + 1 }, (_, i) => start + i)

  const move = (p) => {
    if (p < 1 || p > totalPages) return
    if (p === currentPage) return
    onChange(p)
  }

  const movePrevPage = () => move(currentPage - 1)
  const moveNextPage = () => move(currentPage + 1)
  const movePrevBlock = () => move(start - blockSize)
  const moveNextBlock = () => move(start + blockSize)

  const isFirstPage = currentPage === 1
  const isLastPage = currentPage === totalPages
  const isFirstBlock = start === 1
  const isLastBlock = end === totalPages

  if (pages.length === 0) return null

  return (
    <div className="flex items-center gap-2.5 justify-center mt-6 select-none">
      <ChevronButton
        direction="left"
        isDouble={true}
        disabled={isFirstBlock}
        onClick={movePrevBlock}
      />

      <ChevronButton direction="left" disabled={isFirstPage} onClick={movePrevPage} />

      {pages.map((page) => (
        <button
          key={page}
          onClick={() => move(page)}
          className={`
            min-w-8 h-8 px-2 rounded-lg text-sm font-medium transition cursor-pointer
            ${
              currentPage === page
                ? `${activeStyle} text-white shadow`
                : "bg-white border border-gray-200 hover:bg-gray-100"
            }
          `}
        >
          {page}
        </button>
      ))}

      <ChevronButton direction="right" disabled={isLastPage} onClick={moveNextPage} />

      <ChevronButton
        direction="right"
        isDouble={true}
        disabled={isLastBlock}
        onClick={moveNextBlock}
      />
    </div>
  )
}

export default Pagination
